/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowVideoEditingWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowVideoEditingWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Edit Like a Pro!",
    "Video Editing Awaits!",
    "Let’s Get Creative with Film!",
  ],
  title: "Video Editing Workshop",
  description: "Organize a fun video editing workshop.",
  longDescription:
    "Gather your friends for an engaging video editing workshop! Choose a date, decide on the projects, and plan activities for the session!",
  emoji: "🎥",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Video Editing Workshop",
          emoji: "🎥",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the video editing workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on video projects to work on?",
            description:
              "What video projects should we work on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What projects should we choose?",
                emoji: "🎬",
                completeAction: {
                  question: "Decide on software to use?",
                  description: "What software should we use for editing?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What software should we use?",
                      emoji: "💻",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Editing!",
    outroDescription:
      "Your video editing workshop plans are set! Enjoy the creativity!",
  },
};
